import { createSelector } from 'reselect';
import { get, compose } from 'lodash/fp';
import { getStringProp } from '@mews/fp';
import { mapId, getOrEmptyObject } from '@mews-commander/utils';
import { getSelectedEntityId } from '../../entityManagement/selectors';
import { moduleSelector } from '../module';

export const getFloors = createSelector(moduleSelector, get('floorsStep'));

export const getFloorIds = compose(mapId, getFloors);

const getFloor = createSelector(getStringProp('id'), getFloors, getOrEmptyObject);

export const getSelectedFloor = createSelector(getFloors, getSelectedEntityId, (floor, id) => floor[id]);

export const getSelectedFloorName = compose(get('name'), getSelectedFloor);

export const getFloorName = compose(get('name'), getFloor);
